import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {routerTransition} from '@app/router.animations';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common'
import {ConsultingService, LoaderService} from '@app/shared/services';
import {ToastrService} from 'ngx-toastr';
import {OrderService} from '@app/shared/services/order.service';
import {FormsModule} from '@angular/forms';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {UtilsInjectable} from '@app/shared';
import {environment} from '@env/environment';

@Component({
  selector: 'app-add-purchase',
  templateUrl: './add-purchase.component.html',
  styleUrls: ['./add-purchase.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    DecimalPipe,
    NgbTypeahead,
    NgMultiSelectDropDownModule,
    SelectDropDownModule,
    NgbHighlight,
    PageHeaderComponent,
    NgxMaskDirective
  ],
  providers: [DatePipe, provideNgxMask()]
})
export class AddPurchaseComponent implements OnInit {
  user_rights: any;
  user_data: any;
  public order_list: any = [];
  public purchase_details: any[] = [];
  checked = false;
  public env = environment;
  public purchase: any =
    {
      vendor_id: '',
      invoice_no: '',
      invoice_date: new Date(),
      purchase_id: '',
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      order_quantity_arr: [""],
      order_quantity: [""],
      received_quantity: [""],
      freebie_arr: ["0"],
      purchased_quantity_arr: [""],
      vat_arr: ["0"],
      gross_arr: [""],
      check: [false],
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      user_id: '',
      customer_trn: "",
      sor_no: {},
      customer_ref: "",
      sales_person: "",
      state_code: "",
      upload_file: [],
      warehouse: [""]
    }
  fileName: any = [];
  searching = false;
  searchFailed = false;
  purchase_id: any;
  date: any;
  unit: any;
  purchase_data: any;
  total_amount = 0;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  vendor: any;
  vendor_options: any;
  vendor_data: any;
  purchased: any;
  item_list: any;
  dropdownSettings = {};
  net_total = 0;
  medicine_data: any;
  institution: any;
  total_count = 0;
  warehouse: any;

  constructor(private loaderService: LoaderService,
              public orderService: OrderService,
              public consultingService: ConsultingService,
              private toast: ToastrService,
              protected utils: UtilsInjectable,
              private router: Router,
              private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.institution = JSON.parse(localStorage.getItem('institution') || "{}");

    this.route.params.subscribe(params => {
      this.purchase.purchase_id = Number.parseInt(params['purchase_id']);
      this.getDropdowns();
      this.getUnitList();
      this.listOrderNo();
      this.listWarehouse();
      const id = +(this.route.snapshot.paramMap.get('id') || "");
      if (id != null && id != 0) {
        this.purchase.purchase_id = '';
        this.getPurchaseDetails(id);
      } else {
        this.purchase_details = [{}]
        this.getDropdowns();
      }
    });
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'PURCHASE_ORDER_ID',
      textField: 'PURCHASE_ORDER_NUMBER',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public listWarehouse() {
    const postData = {
      warehouse_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listWarehouse(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.warehouse = result['data'];
      }
      this.loaderService.display(false);
    });
  }

  public listOrderNo() {
    const postData = {
      vendor_id: this.purchase.vendor_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listOrderNo(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.order_list = result['data'];
        this.loaderService.display(false);
      } else {
        this.order_list = "";
        this.loaderService.display(false);
      }
    });
  }

  getVendor(data: any) {
    if (data['value']) {
      this.purchase.sor_no = {};
      this.clear_purchase();
      this.purchase.vendor_id = data['value'].VENDOR_ID;
      this.purchase.customer_trn = data['value'].TRN_NO;
      this.purchase.state_code = data['value'].VENDOR_STATECODE;
    }
  }

  public set_item_medicine($event: any, i: any): any {
    if (this.purchase.vendor_id == "") {
      this.purchase.medicine_data = ''
      this.toast.error("Please select supplier name");
      return false;
    }
    this.purchase.purchased_quantity_arr[i] = ''
    this.purchase.vat_arr[i] = '0'
    this.purchase.amount_arr[i] = ''
    this.purchase.unitprice_arr[i] = ''
    this.purchase.retailprice_arr[i] = ''
    this.purchase.freebie_arr[i] = '0'
    this.purchase.gross_arr[i] = ''
    this.purchase.gross_arr[i] = ''

    const item = $event.item;
    this.purchase.medicine_id_arr[i] = item.MEDICINE_ID;
    this.purchase.uom_arr[i] = item.UNIT;
    this.purchase.uom_arr_name[i] = item.UNIT_DESC;
    this.purchase.order_quantity_arr[i] = item.ORDER_QUANTITY;
    this.purchase.received_quantity[i] = item.RECEIVED_ORDER_QUANTITY;
    if (this.purchase.sor_no.length > 0) {
      this.purchase.order_quantity[i] = item.RECEIVED_ORDER_QUANTITY + ' / ' + item.ORDER_QUANTITY;
    }
    this.getMedicine(item, i);
  }

  public getUnitList() {
    const postData = {
      unit_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listUnit(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.unit = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public clear_purchase() {
    this.purchase_details = [{}]
    this.total_amount = 0;
    this.purchase = {
      vendor_id: '',
      invoice_no: '',
      invoice_date: new Date(),
      purchase_id: '',
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      purchased_quantity_arr: [""],
      vat_arr: ["0"],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      order_quantity_arr: [""],
      received_quantity: [""],
      order_quantity: [""],
      freebie_arr: ["0"],
      gross_arr: [""],
      check: [""],
      freight_charge: 0,
      discount: 0,
      disc_per: 0,
      user_id: '',
      sor_no: {},
      warehouse: [""],
      upload_file: []
    }
    this.fileName = [];
    this.vendor_data = ""
    this.net_total = 0
    this.getDropdowns();
  }

  public currentQuantity() {
    let id = 0;
    let purch_qty = 0;
    let result = false;
    for (let i = 0; i < this.purchase.medicine_id_arr.length; i++) {
      id = this.purchase.medicine_id_arr[i]
      if (id == this.purchase.medicine_id_arr[i]) {
        purch_qty = purch_qty + this.purchase.purchased_quantity_arr[i];
      } else {
        id = this.purchase.medicine_id_arr[i]
      }
    }
    return result;
  }

  public savePurchaseDetails(): any {
    if (this.purchase.vendor_id == '') {
      this.toast.error('Please Select a Vendor !');
      return false;
    }
    if (this.purchase.invoice_no == '') {
      this.toast.error('Please Enter Invoice Number !');
      return false;
    }
    if (this.purchase.invoice_date == '') {
      this.toast.error('Please Select Invoice Date !');
      return false;
    }
    if (!this.purchase_details?.some((item) =>
        (Array.isArray(item.check) && item.check.some((val: boolean) => val)) || item.check === true )) {
      this.toast.error('Please Add At Least One Particular!');
      return false;
    }

    let rel = 1;
    this.purchase.uom_arr_name.forEach((item: any, index: any): any => {
      this.purchase.check[index] = this.purchase_details[index].check;
      if (this.purchase_details[index].check == true) {
        if (this.purchase.warehouse[index] == "") {
          this.toast.error('Select a warehouse');
          rel = 0;
          return false;
        }
        if (this.purchase.purchased_quantity_arr[index] == "") {
          this.toast.error('Enter particular quantity');
          rel = 0;
          return false;
        }
        if (this.purchase.purchased_quantity_arr[index] != "") {
          if (this.currentQuantity()) {
            rel = 0;
            return false;
          }
        }
        if (this.purchase.amount_arr[index] == "") {
          this.toast.error('Enter amount ');
          rel = 0;
          return false;
        }
        if (this.purchase.retailprice_arr[index] == "") {
          this.toast.error('Enter retail price ');
          rel = 0;
          return false;
        }
      }
    });
    if (rel == 0) {
      return false
    }
    let total_qty = 0
    this.purchase.amount_arr.forEach((item: any, index: any) => {
      if (this.purchase_details[index].check == true) {
        const freebie = parseInt(this.purchase.freebie_arr[index]);
        const qty = parseInt(this.purchase.purchased_quantity_arr[index]);
        if (this.purchase_details[index].check == true) {
          if (!isNaN(freebie && qty)) {
            total_qty = qty + freebie;
          }
          this.purchase.quantity_arr[index] = total_qty
        }
      }
    });
    // Recalculate total and net before saving
    this.totalAmount();
    this.purchase.gross_total = this.total_amount || 0;
    this.purchase.net_total = this.net_total || 0;

    this.purchase.user_id = this.user_data.user_id
    this.purchase.purchase_id = this.purchase_id
    this.loaderService.display(true);

    this.consultingService.savePurchaseDeatils(this.purchase).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toast.success(result.msg);
        this.purchase.puchase_id = result.data_id;
        this.router.navigate(['purchase/purchase-list']).then();
        this.clear_purchase();
      } else {
        this.toast.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public getMedicine(data: any, i: any) {
    const postData = {
      medicine_id: data.MEDICINE_ID
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.getMedicine(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        const medilist_data = result['data'];
        this.purchase.medicine_name = medilist_data.TRADE_NAME;
        this.purchase.medicine_code = medilist_data.DDC_CODE;
        this.purchase.medicine_id_arr[i] = medilist_data.MEDICINE_ID;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  selectFiles($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      const filesAmount = $event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName.push($event.target.files[i])
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const image = event.target.result;
          const splitted = image.split(",");
          this.purchase.upload_file.push(splitted[1]);
        }
        reader.readAsDataURL($event.target.files[i]);
      }
    }
  }

  public totalAmount() {
    let sum = 0;
    this.purchase.gross_arr.forEach((item: any, index: any) => {
      if (this.purchase_details[index].check == true) {
        const amount = parseFloat(this.purchase.gross_arr[index]);
        if (!isNaN(amount)) {
          sum = sum + amount;
        }
      }
    });
    this.total_amount = sum;
    const discper = parseFloat(this.purchase.disc_per);
    if (!isNaN(discper)) {
      const discount = (this.total_amount * (discper / 100));
      this.purchase.discount = discount.toFixed(2)
      this.net_total = Math.round(this.total_amount + parseFloat(this.purchase.freight_charge) - discount);
    } else {
      this.net_total = Math.round(this.total_amount)
    }
  }

  public getUnitPrice() {
    let price = 0;
    this.purchase.purchased_quantity_arr.forEach((item: any, index: any) => {
      if (this.purchase_details[index].check == true) {
        const amount = parseFloat(this.purchase.amount_arr[index]);
        const qty = parseFloat(this.purchase.purchased_quantity_arr[index]);
        if (!isNaN(amount && qty)) {
          price = amount / qty;
        }
        this.purchase.unitprice_arr[index] = price.toFixed(2)
      }
    });
  }

  public getActualPrice() {
    let actual = 0;
    this.purchase.purchased_quantity_arr.forEach((item: any, index: any) => {
      if (this.purchase_details[index].check == true) {
        const amount = parseFloat(this.purchase.amount_arr[index]);
        const qty = parseFloat(this.purchase.purchased_quantity_arr[index]);
        const free_qty = parseFloat(this.purchase.freebie_arr[index]);
        if (!isNaN(amount && qty && free_qty)) {
          actual = amount / (qty + free_qty);
        }
        this.purchase.actual_arr[index] = actual.toFixed(2)
      }
    });

  }

  public getAmount() {
    let vat_amount = 0;
    this.purchase.amount_arr.forEach((item: any, index: any) => {
      if (this.purchase_details[index].check == true) {
        const amount = parseFloat(this.purchase.amount_arr[index]);
        const vat = parseFloat(this.purchase.vat_arr[index]);
          if (!isNaN(amount && vat)) {
            vat_amount = amount * (vat / 100)
          }
          this.purchase.gross_arr[index] = (amount + vat_amount).toFixed(2)
      }
    });
  }


  onItemSelect() {
    this.listOrderMedicine();
  }

  onSelectAll(items: any) {
    this.purchase.sor_no = items
    this.listOrderMedicine();
  }

  public changeCheckbox(i: any) {
    if (!this.purchase_details[i]) {
      this.purchase_details[i] = { check: true };
    } else {
      this.purchase_details[i].check = !this.purchase_details[i].check;
    }
  }

  public listOrderMedicine() {
    const postData = {
      order_id: this.purchase.sor_no,
      vendor_id: this.purchase.vendor_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.consultingService.listOrderMedicine(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.medicine_data = result['data'];
        let i = 0;
        const purchase_details = [];
        for (const val of result['data']) {
          purchase_details.push({check: true});
          this.purchase.medicine_data[i] = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
            'DDC_CODE': val.DDC_CODE,
            'SCIENTIFIC_CODE': val.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': val.SCIENTIFIC_NAME
          };
          this.purchase.warehouse[i] = '';
          this.purchase.medicine_id_arr[i] = val.MEDICINE_ID;
          this.purchase.quantity_arr[i] = '';
          this.purchase.uom_arr[i] = val.UNIT;
          this.purchase.uom_arr_name[i] = val.UNIT_DESC;
          this.purchase.paking_arr[i] = '';
          this.purchase.amount_arr[i] = '';
          this.purchase.unitprice_arr[i] = '';
          this.purchase.retailprice_arr[i] = '';
          this.purchase.freebie_arr[i] = '0';
          this.purchase.order_quantity_arr[i] = val.ORDER_QUANTITY;
          this.purchase.order_quantity[i] = val.RECEIVED_ORDER_QUANTITY + ' / ' + val.ORDER_QUANTITY;
          this.purchase.received_quantity[i] = val.RECEIVED_ORDER_QUANTITY;
          this.purchase.dis_arr[i] = ' ';
          this.purchase.check[i] = true;
          this.purchase_details[i] = {check: true};

          i = i + 1;
        }

        if (result['data'].length == 0) {
          purchase_details.push({check: true});
          this.purchase.medicine_data[i] = '';
          this.purchase.medicine_id_arr[i] = '';
          this.purchase.uom_arr_name[i] = '';
          this.purchase.unitprice_arr[i] = '';
          this.purchase.retailprice_arr[i] = '';
          this.purchase.amount_arr[i] = '';
          this.purchase.paking_arr[i] = '';
          this.purchase.order_quantity_arr[i] = '';
          this.purchase.order_quantity[i] = '';
          this.purchase.received_quantity[i] = '';
          this.purchase.freebie_arr[i] = '0';
          this.purchase.gross_arr[i] = '';
        }

        this.purchase_details = purchase_details;
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  public addrow(index: any) {
    this.purchase_details[index + 1] = {check: true};
    this.purchase.medicine_data[index + 1] = '';
    this.purchase.purchased_quantity_arr[index + 1] = '';
    this.purchase.vat_arr[index + 1] = '0';
    this.purchase.uom_arr_name[index + 1] = '';
    this.purchase.uom_arr[index + 1] = '';
    this.purchase.unitprice_arr[index + 1] = '';
    this.purchase.retailprice_arr[index + 1] = '';
    this.purchase.amount_arr[index + 1] = '';
    this.purchase.paking_arr[index + 1] = '';
    this.purchase.order_quantity_arr[index + 1] = '';
    this.purchase.freebie_arr[index + 1] = '0';
    this.purchase.gross_arr[index + 1] = '';
    this.purchase.check[index + 1] = true;
    this.totalAmount();
  }

  public deleterow(index: any) {
    this.purchase_details.splice(index, 1);
    this.purchase.medicine_data.splice(index, 1);
    this.purchase.medicine_id_arr.splice(index, 1);
    this.purchase.purchased_quantity_arr.splice(index, 1);
    this.purchase.uom_arr.splice(index, 1);
    this.purchase.uom_arr_name.splice(index, 1);
    this.purchase.unitprice_arr.splice(index, 1);
    this.purchase.amount_arr.splice(index, 1);
    this.purchase.retailprice_arr.splice(index, 1);
    this.purchase.paking_arr.splice(index, 1);
    this.purchase.dis_arr.splice(index, 1);
    this.purchase.order_quantity_arr.splice(index, 1);
    this.purchase.freebie_arr.splice(index, 1);
    this.purchase.gross_arr.splice(index, 1);
    this.totalAmount();
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }
    this.loaderService.display(true);
    this.consultingService.listVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.total_count = result['total_count']
        this.vendor = result['data'];
        this.vendor_options = this.vendor;
        for (let index = 0; index < this.vendor_options.length; index++) {
          if (this.vendor_options[index].VENDOR_ID == this.purchase.vendor_id) {
            this.vendor_data = this.vendor_options[index];
          }
        }
      }
    });
  }

  public getPurchaseDetails(id: any) {
    this.getDropdowns();
    const postData = {
      purchase_id: id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.purchase.vendor_id = this.purchased.VENDOR_ID;
        this.purchase.invoice_no = this.purchased.INVOICE_NUMBER;
        this.purchase.invoice_date = this.purchased.INVOICE_DATE;
        this.purchase.purchase_id = this.purchased.PURCHASE_ID;
        this.purchase.customer_trn = this.purchased.CUSTOMER_TRN;
        this.purchase.sor_no = this.purchased.SOR_NO;
        this.purchase.customer_ref = this.purchased.CUSTOMER_REFERENCE;
        this.purchase.sales_person = this.purchased.SALES_PERSON;
        let i = 0;
        this.purchase_details = ['0'];
        const num_rows = [];
        for (const val of result['data'].PURCHASE) {
          const temp = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
          };
          num_rows[i] = i;
          num_rows.push(i);
          this.purchase.medicine_id_arr[i] = temp;
          this.purchase.quantity_arr[i] = val.QUANTITY;
          this.purchase.uom_arr_name[i] = val.UNIT_DESC;
          this.purchase.unitprice_arr[i] = val.UNIT_PRICE;
          this.purchase.retailprice_arr[i] = val.MRP;
          this.purchase.dis_arr[i] = val.DISCOUNT;
          i = i + 1;
        }
        this.loaderService.display(false);
      } else {
        this.purchase = {
          vendor_id: '',
          invoice_no: '',
          invoice_date: new Date(),
          purchase_id: '',
          medicine_data: [],
          medicine_id_arr: [""],
          quantity_arr: [""],
          uom_arr: [""],
          uom_arr_name: [""],
          paking_arr: [""],
          amount_arr: [""],
          actual_arr: [""],
          unitprice_arr: [""],
          retailprice_arr: [""],
          dis_arr: [""],
          user_id: '',
          customer_trn: "",
          sor_no: {},
          customer_ref: "",
          sales_person: "",
          state_code: "",
          warehouse: [""],
          upload_file: [],
          order_quantity_arr: [""],
          received_quantity: [""],
          order_quantity: [""],
          freebie_arr: ["0"],
          gross_arr: [""],
          check: [""],
        }
        this.fileName = [];
        this.loaderService.display(false);
      }
    });
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.orderService.medicine_purchase_search(term, this.purchase.sor_no, this.purchase.vendor_id).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: {
    TRADE_NAME: string,
    DDC_CODE: string,
    SCIENTIFIC_NAME: string,
    MEDICINE_ID: number,
    SCIENTIFIC_CODE: number
  }): any => x.TRADE_NAME;
}
